import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { themeGet } from 'modules/v2/foundation/theme';
export const AccordionContainer = styled(Accordion.Root) `
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.background.50')};
  gap: ${themeGet('spacing.sm')};
`;
